
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import MalikiBilgisiForm from "@/components/forms/MalikiBilgisiForm.vue";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import {ItemArrayManagerTableHeader} from "@/interface/TableHeader";
import FormWrapper from "@/components/FormWrapper.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import Plaka from "@/components/inputs/Plaka.vue";

@Component({
  components: {Plaka, ItemArrayManager, MalikiBilgisiForm, FormWrapper},
})
export default class TasinirBilgisiForm extends Mixins(ObjectInputMixin) {
  @Prop() hideButtons!: boolean | string;
  @Prop() alacak !: any;

  aciklamayaEklenecekBilgi:string=''

  save(){
    if (this.alacak.id){
      this.localValue.alacak_id = this.alacak.id
      if (this.localValue.id){
        this.$http.put('/api/v1/tasinir/' + this.localValue.id,this.localValue)
      }else{
        this.$http.post('/api/v1/alacak/' + this.alacak.id + '/tasinirlar',this.localValue)
      }
    }
    this.$emit("onSuccess");
    this.$emit("addTasinir",this.localValue);
  }

  headers: Array<ItemArrayManagerTableHeader> = [
    {
      value: "isim",
      text: "İsim",
    },
    {
      value: "tc_no",
      text: "TC No",
    },
  ];

  get aciklama() {
    if (this.localValue.tur == 'arac' && this.localValue.plaka && this.localValue.marka_model) {
      return this.localValue.plaka.toUpperCase() + " plakalı " + this.localValue.marka_model + " marka modelli araç " + this.aciklamayaEklenecekBilgi;
    }
  }

  get isHideButtons() {
    return this.hideButtons || this.hideButtons === "";
  }

  @Watch("aciklama")
  onAciklamaChange() {
    this.localValue.aciklama = this.aciklama;
  }
}
